<template>
    <Head>
        <title>blog</title>
        <meta
            name="description"
            content="Blog | Search CDL Jobs All You Need is a Zip code"
        />
        <meta
            name="keywords"
            content="Truck Driving Jobs,Truck Driving Jobs Near Me"
        />
        <meta property="og:title" content="Blog" />
        <meta property="og:site_name" content="opencdljobs.com" />
        <meta
            property="og:description"
            content="Blog | Search CDL Jobs All You Need is a Zip code"
        />
        <meta property="og:type" content="article" />
        <meta
            property="og:image"
            content="opencdljobs.com/images/opencdljobs.png"
        />
    </Head>

    <div class="flex justify-center">
        <main
            class="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white dark:bg-gray-900 antialiased"
        >
            <div v-if="articles.data.length == 0">
                <p class="text-lg tracking-wide">
                    Sorry, We haven't post anyting yet !
                </p>
            </div>
            <div v-else class="grid grid-cols-12 gap-4 px-4 max-w-screen-xl">
                <article
                    class="col-span-12 xl:col-span-6 border rounded-md p-4 w-full max-w-2xl format format-sm sm:format-base lg:format-lg format-blue dark:format-invert"
                    v-for="article in articles.data"
                    :key="article.id"
                >
                    <header class="mb-4 lg:mb-6 not-format">
                        <h1 class="pb-4">
                            <a
                                :href="
                                    route('blog.article.show', {
                                        article_category:
                                            article.article_category?.slug,
                                        article: article.slug,
                                    })
                                "
                                rel="author"
                                class="mb-4 text-3xl font-extrabold leading-tight text-gray-900 lg:mb-6 lg:text-4xl dark:text-white hover:text-blue-600"
                                >{{ article.title }}</a
                            >
                        </h1>

                        <div class="mb-6">
                            <small
                                class="tracking-wider mb-4 bg-gray-50 px-4 py-1 border rounded"
                                ># {{ article.article_category?.name }}</small
                            >
                        </div>

                        <address class="flex items-center mb-6 not-italic">
                            <div
                                class="inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white"
                            >
                                <img
                                    class="mr-2 w-7 h-7 rounded-full border"
                                    :src="
                                        'https://eu.ui-avatars.com/api/?name=' +
                                        article.author.name +
                                        '&size=250'
                                    "
                                    :alt="article.author.name"
                                />
                                <div class="flex items-center space-x-4">
                                    <h3
                                        class="text-md font-semibold text-gray-500 dark:text-white"
                                    >
                                        {{ article.author.name }}
                                    </h3>
                                    <small
                                        class="text-gray-500 dark:text-gray-400"
                                    >
                                        <time
                                            pubdate
                                            :datetime="article.published_at"
                                            :title="article.published_at"
                                            >{{
                                                publishedAt(
                                                    article.published_at
                                                )
                                            }}</time
                                        >
                                    </small>
                                </div>
                            </div>
                        </address>

                        <div class="flex justify-between">
                            <div class="flex items-center space-x-1">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-4 h-4"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>

                                <small>{{
                                    article.reading_time_estimation
                                }}</small>
                            </div>
                            <a
                                :href="
                                    route('blog.article.show', {
                                        article_category:
                                            article.article_category?.slug,
                                        article: article.slug,
                                    })
                                "
                                class="flex items-center space-x-2 hover:text-blue-600 hover:scale-105 duration-150"
                            >
                                <small>Read Article</small>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-6 h-6"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                    />
                                </svg>
                            </a>
                        </div>
                    </header>
                </article>
            </div>
        </main>
    </div>
</template>

<script setup>
import { Head } from "@inertiajs/inertia-vue3";
import Pagination from "@/components/Pagination";
import { DateTime } from "luxon";
const props = defineProps({
    articles: Object,
});

const { articles } = props;

const route = window.route;

function publishedAt(published_at) {
    return DateTime.fromISO(published_at).toLocaleString(DateTime.DATE_MED);
}
</script>

<style></style>
